import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Lenis from "lenis";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { StickyContact } from "@/components/StickyContact";
import Home from "@/pages/Home";
import ServicesIndex from "@/pages/ServicesIndex";
import ServiceDetail from "@/pages/ServiceDetail";
import LocationsIndex from "@/pages/LocationsIndex";
import CityDetail from "@/pages/CityDetail";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import RegionPage from "@/pages/RegionPage";
import Contact from "@/pages/Contact";

const ScrollToTop = () => {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);
    return null;
};

function App() {
    useEffect(() => {
        const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
        };
    }, []);

    return (
        <HelmetProvider>
            <BrowserRouter>
                <ScrollToTop />
                <Navbar />
                <main className="pt-16">
                    <Routes>
                        <Route path="/" element={<Home />} />
                        <Route path="/services" element={<ServicesIndex />} />
                        <Route path="/services/:slug" element={<ServiceDetail />} />
                        <Route path="/locations" element={<LocationsIndex />} />
                        <Route path="/locations/:slug" element={<CityDetail />} />
                        <Route path="/regions/:slug" element={<RegionPage />} />
                        <Route path="/blog" element={<BlogIndex />} />
                        <Route path="/blog/:slug" element={<BlogPost />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                </main>
                <Footer />
                <StickyContact />
            </BrowserRouter>
        </HelmetProvider>
    );
}

export default App;
